import { render, staticRenderFns } from "./ShopsOverall2021.vue?vue&type=template&id=5fe5e14e&scoped=true&"
import script from "./ShopsOverall2021.vue?vue&type=script&lang=js&"
export * from "./ShopsOverall2021.vue?vue&type=script&lang=js&"
import style0 from "./ShopsOverall2021.vue?vue&type=style&index=0&id=5fe5e14e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe5e14e",
  null
  
)

export default component.exports